
import React from "react";

import BsyDashChartBase from '../BsyDashChartBase'
import { BsyConfig } from '../../../global/BsyConfig'
import BsySLoading from '../../BsySLoading';

import './index.css';
import { BsyUtils } from "../../../utils/Utils";

export default class BsyDashGaugeChart extends BsyDashChartBase {


    constructor(props) {
        super(props)
        this.state = {
            ...this.state
        }
    }

    _initChartOption = (e, i, n, r, a) => {
        const { range, attrList, valueFields } = this.state;

        let _this = this
            , opt = _this.props;
        if (e) {
            i = [React.language("report.chart.legend", {
                val: "1"
            }), React.language("report.chart.legend", {
                val: "2"
            })]
            n = [React.language("report.chart.category", {
                val: "1"
            }), React.language("report.chart.category", {
                val: "2"
            }), React.language("report.chart.category", {
                val: "3"
            }), React.language("report.chart.category", {
                val: "4"
            }), React.language("report.chart.category", {
                val: "5"
            })]
            r = [[1, 3, 8, 7, 9], [8, 6, 4, 2, 7]]
        }

        if (!r || r.length == 0) {
            this.setState({
                dataEmpty:true,
            })
            return;
        }
        this.setState({
            dataEmpty:false,
        },()=>{

            let option = {};
            let option1 = this._renderOptions(option, i, n, r);
            if (this.myCharts) {
                this.myCharts.dispose();
                this.echartsRef.current.innerHTML = '';
            }
            this.myCharts = window.echarts.init(this.echartsRef.current);
            if (option1.onFinished) {
                this.myCharts.on('finished', function () {
                    option1.onFinished && option1.onFinished(_this.myCharts);
                });
            }
            this.myCharts.on('click', function (params) {
                let i = [];
                if (_this.yGroups && _this.yGroups[0]) {
                    let n = params.seriesName || params.name;
                    if(_this.nameMap[n]) {
                        n = _this.nameMap[n];
                    }
                    let r = _this._dealLinkData(_this.yGroups[0], n);
                    r.field = _this.yGroups[0].name
                    i.push(r)
                }
                if (_this.xGroups && _this.xGroups[0]) {
                    let a = params.category || params.name
                        , o = _this.name || _this.nameMap[a] || a
                        , s = _this._dealLinkData(_this.xGroups[0], o);
                    s.field = _this.xGroups[0].name
                    i.push(s)
                }
                if (_this.state.valueFields[0]) {
                    _this.linkParam = _this._getLinkFilterParams(i)
                    BsyUtils.applyFunc(_this, opt.onItemClick, [_this.linkParam], !1)
                }
            });
            this.myCharts.setOption(option1)
        })

    }

    _getColors = () => {
        let a = this
            , o = this.props;
        const { valueFields } = this.state;
        let colors = [];
        let color = [];
        let DASH_CHART_THEME = [];
        let range = o.range.split(',').map(Number)
            , max = range[range.length - 1]
            , min = range[0];
        BsyUtils.forEach(BsyConfig().CONST.DASH_CHART_THEME, function (obj, val) {
            if (val.value === a.palette) {
                DASH_CHART_THEME = val.colors;
                if (valueFields[0].colors) {
                    BsyUtils.forEach(valueFields[0].colors, function (obj1, val1) {
                        if (val1) {
                            colors.push(val1.color)
                        } else {
                            colors = val[obj1 - 10 * Math.floor(obj1 / 10)].colors
                        }
                    })
                } else {
                    colors = DASH_CHART_THEME
                }
            }
        })

        a.rangeList = [];
        BsyUtils.forEach(range, function (obj, val) {
            let co = ""
            if ((colors.length + 1) < range.length) {
                co = colors[obj - Math.floor(obj / 10) * 10]
            } else {
                co = colors[obj]
            }
            if (obj + 1 < range.length) {
                a.rangeList.push({
                    data: [range[obj], range[obj + 1]],
                    color: co || DASH_CHART_THEME[obj - Math.floor(obj / 10) * 10]
                })
            }
        });

        let sum = 0;
        BsyUtils.forEach(a.rangeList, function (a1, b1) {
            let v = Math.abs(b1.data[1] - b1.data[0]);
            sum += v;
        })
        let last = 0;
        BsyUtils.forEach(a.rangeList, function (obj, val) {
            let v = Math.abs(val.data[1] - val.data[0]);
            let z = v / sum;
            last = z + last;
            color.push([
                last, val.color
            ])
        })

        return color;
    }
  
}